<template>
  <div class="component-container loud-speaker-list">
    <div class="container-head">
      <div class="paper-head-title">
        <i class="icon-icon_danao2 iconfont" style="color: rgb(52 197 231);font-size: 30px"></i>
        <span class="paper-tabal">资料</span>
        <span class="paper-text"> > 文库> 自留地 </span>
        <common-button style="float: right" size="default" type="cancel" image @click="handleCancelClick()">返回</common-button>
      </div>
    </div>

    <div class="container-body">
      <div class="form-heard">
        <el-form label-width="70px" style="margin-bottom: 20px">
          <div class="AchievementList-list-body-main-fastener">
            <button type="button" style="float: left;background-color: rgb(13 144 246);font-size: 15px;" class=" AchievementList-list-body-main-button icon-icon_wenjianjia iconfont " @click="openFile">&nbsp;&nbsp;新建文件夹</button>
            <button type="button" class=" AchievementList-list-body-main-button-down icon-daochu iconfont " @click="importFile">导入</button>
            <button type="button" class=" AchievementList-list-body-main-button-down icon-xiazai iconfont " @click="download">下载</button>
            <div class="pending-items-search" style="text-align: left;">
              <input placeholder="搜索" class="input-catch"></input>
              <i class="iconfont icon-sousuo" @click="catchFilw" type="button"></i>
            </div>
          </div>
        </el-form>
      </div>
      <div class="form-body">
        <div class="loud-speaker-list-table-card">
          <el-table :data="data.list"
                    :header-cell-style="{ background: '#E5F5F9',fontSize:'16px',color:'#353739' }"
                    :cell-style="{}"
                    :row-style="tableRowClassName">
            <el-table-column
              type="selection"
              align="center"
              width="70">
            </el-table-column>
            <el-table-column width="50px" prop="icon" label="">
              <template slot-scope="scope" class="icon-file">
                <!--                <i :class="scope.row.attachIds | fileIcon(this_)"></i>-->
                <i :class="scope.row.icon+' iconfont'"></i>
              </template>
            </el-table-column>
            <el-table-column width="500px" align="left" prop="title" label="名称">
              <template slot-scope="scope">
                <span style="font-size: 16px">{{scope.row.title}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="createTm" label="修改时间">
              <template slot-scope="scope">
                <span style="font-size: 16px">{{scope.row.createTm| datetimeFormat}}</span>
              </template>
            </el-table-column>
            <el-table-column width="200px" align="center" prop="totalAttaSize" label="大小">
              <template slot-scope="scope">
                <span style="font-size: 16px">{{scope.row.totalAttaSize | fileSizeUnit }}</span>
              </template>
            </el-table-column>
<!--            <el-table-column width="200px" align="center" label="操作">-->
<!--              <template slot-scope="scope">-->
<!--                <button type="button" class="eims-button eims-button&#45;&#45;text" style="margin-top: -5px;" @click.stop="loudSpeakerFilePrev(scope.row)" title="">预览</button>-->
<!--                <button type="button" class="eims-button eims-button&#45;&#45;text" style="margin-top: -5px;" @click.stop="loudSpeakerFileUpdate(scope.row)" title="">修改</button>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
        </div>
        <span style="float: right">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="data.total">
              </el-pagination>
            </span>
      </div>
    </div>
    <animation :loadingDataVisible="(!attachmentUploadState || !formInfoSaveState) || data.isLoading" :loadingText="loadingText"></animation>
    <!--      <div class="case-share-list-foot"></div>-->

    <LoudSpeakerDetail :edit-flag="dialog.editFlag" v-if="dialog.isShow" @closeDialog="closeDialog"/>
  </div>



</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {mapState} from "vuex";
import {Message} from "element-ui";
import {DIALOG_TYPE_ADD,DIALOG_TYPE_VIEW,DIALOG_TYPE_UPDATE,ATTA_FILE_SUF_LIST,ATTA_FILE_SHOW_TYPE,ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
  CARD_HEIGHT_TYPE,TAB_HEIGHT_TYPE,ATTA_FILE_DOWN_TYPE,PAGE_SIZE_TYPE,ATTA_UPLOAD_COMPONENT_TYPE_STR,SINGLE_ATTACHMENT_MAX_SIZE} from '@/constants/constants'
import animation from '@/components/loading/animation'
import LoudSpeakerDetail from "../../components/detail/LoudSpeakerDetail";
export default {
  name: "PaperList",
  components:{LoudSpeakerDetail, animation},
  data(){
    return{
      this_:this,//保存this以便filters中使用
      //true是结束,false是正在处理
      attachmentUploadState:true,
      //true是结束,false是正在处理
      formInfoSaveState:true,
      loadingText:null,
      data:{
        list:[
          {
            icon:'icon-wenjianjia',
            title:'文章标题',
            createTm:'2022-01-01 17:34:23',
            totalAttaSize:'5.2M',
          },
          {
            icon:'icon-file-ppt-fill',
            title:'文章标题',
            createTm:'2022-01-01 17:34:23',
            totalAttaSize:'5.2M'
          },
          {
            icon:'icon-file-excel-fill',
            title:'文章标题',
            createTm:'2022-01-01 17:34:23',
            totalAttaSize:'5.2M',
          },
          {
            icon:'icon-file-excel-fill',
            title:'文章标题',
            createTm:'2022-01-01 17:34:23',
            totalAttaSize:'5.2M',
          },
          {
            icon:'icon-file-word-fill',
            title:'文章标题',
            createTm:'2022-01-01 17:34:23',
            totalAttaSize:'5.2M',
          },
          {
            icon:'icon-PDF',
            title:'文章标题',
            createTm:'2022-01-01 17:34:23',
            totalAttaSize:'5.2M',
          },
        ],
        isLoading:false,
        pageNum: 1,
        pageSize: 9,
        total: 9,
        currentPage: 1
      },
      fileIconType:{
        'ppt':'icon-file-ppt-fill',
        'xls':'icon-file-excel-fill',
        'xlsx':'icon-file-excel-fill',
        'word':'icon-file-word-fill',
        'pdf':'icon-PDF',
        'doc':'icon-wenjianjia'
      },
      LoudSpeakerData:[],
      form:{
        title:'',
        content:'',
        createName:'',
        createTm:[
          this.moment().subtract(7,'day').format('yyyy-MM-DD HH:mm:ss'),
          this.moment().subtract(0,'day').format('yyyy-MM-DD HH:mm:ss')
        ],

      },
      dialog:{
        isShow: false,
        caseId:null,
        editFlag:'view',
      }

    }
  },
  filters:{
    //取截单元,单位
    fileSizeUnit:(arg)=> {
      if (parseFloat(arg)/(1024*1024) > 1){
        return (parseFloat(arg)/(1024*1024)).toFixed(2) + 'M'
      }else if (parseFloat(arg)/(1024) > 1) {
        return (parseFloat(arg)/(1024)).toFixed(2) + 'K'
      }else {
        return arg + 'B';
      }
    },
    fileIcon:function (arg,this_) {
      if (arg.length>0){
        let type= arg[0].attachmentOriginalName.substring(arg[0].attachmentOriginalName.lastIndexOf('.') + 1)
        return (this_.fileIconType[type]+' iconfont')
      }
      return '';
    }
  },
  methods:{
    openFile(){

    },
    importFile(){

    },
    download(){

    },
    catchFilw(){

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex%2 === 0) {
        return '';
      }
      let clzz = {
        background: '#F3FDFF'+ '!important'
      };
      return clzz;
    },
    handleCancelClick(){
      this.$router.push({path: '/library/LibraryList'})
    },
    // openFile() {
    //   this.dialog.isShow = true;
    //   this.dialog.editFlag = 'add';
    // },
    closeDialog(){
      this.dialog.isShow = false;
    },
    caseShareFilePrev(row){

      this.dialog.caseId = Number(row.id);
    },
    caseShareFileUpdate(row){

      this.dialog.caseId = Number(row.id);
    },
    handleSelectionChange(){

    }
  }
}
</script>

<style scoped>
.loud-speaker-list{
  margin: 20px;
}
.paper-tabal{
  margin-top: 2px;
  position: absolute;
  padding-left: 10px;
  font-family: SourceHanSansSC;
  font-weight: 700;
  font-size: 24px;
  color: rgb(8, 39, 44);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
}
.paper-text{
  margin-top: 2px;
  position: absolute;
  margin-left: 65px;
  border: none;
  /* padding-left: 5px; */
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 18px;
  color: rgb(8, 39, 44);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
}
/*.triangle-list-button{*/
/*  border: 1px solid rgb(105,185,252);*/
/*  border-radius: 3px;*/
/*  width: 80px;*/
/*  height: 40px;*/
/*  text-align: center;*/
/*  background-image: url('/static/images/fourbackground.png');*/
/*}*/
.loud-speaker-list-table-card{
  height: calc(100vh - 302px);
  overflow-y: auto;
  overflow-x: hidden;
}
/*.eims-button {*/
/*  font-size: 16px;*/
/*  margin-left: 10px;*/
/*}*/
/*.eims-button--text{*/
/*  border-color: transparent;*/
/*  color: #409eff;*/
/*  background: transparent;*/
/*}*/
/*.eims-button:focus {*/
/*  outline: none;*/
/*}*/
/deep/ .el-table .cell{
  line-height: unset;
}
/*.LoudSpeaker-list-body{*/
/*  width: 100%;*/
/*  border-radius: 8px;*/
/*  background-color: #FFF;*/
/*  overflow: hidden;*/
/*  box-shadow: 1px 2px 5px #ccc;*/
/*  padding: 10px 20px 20px 20px;*/

/*}*/
/*.LoudSpeaker-list-body-title{*/
/*  border-bottom: 1px solid #F5F5F5;*/
/*  !*border-bottom: 1px solid black;*!*/
/*  padding: 20px 20px 20px 20px;*/
/*  line-height: 20px;*/
/*}*/
/*.LoudSpeaker-list-body-text{*/
/*  font-size: 18px;*/
/*  font-weight: bold;*/
/*  float: left;*/
/*}*/
/*.LoudSpeaker-list-body-button{*/
/*  font-size: 12px;*/
/*  float: right;*/
/*  padding: 6px ;*/
/*  width: 50px;*/
/*  !*margin-bottom: 60px;*!*/
/*  border: 1px solid rgb(105,185,252);*/
/*  color:rgb(105,185,252) ;*/
/*  background-color: white;*/
/*  border-radius: 5px;*/
/*}*/
/*.LoudSpeaker-list-body-main{*/
/*  width: 100%;*/
/*  padding: 10px;*/
/*}*/
/*.LoudSpeaker-list-body-main-fastener{*/
/*  padding: 10px;*/

/*}*/
/*.LoudSpeaker-list-body-main-button{*/
/*  border: 1px solid rgb(105,185,252);*/
/*  color: rgb(105,185,252);*/
/*  border-radius: 3px;*/
/*  width: 80px;*/
/*  height: 40px;*/
/*  text-align: center;*/
/*  font-size: 12px;*/
/*  background-image: url('/static/images/fourbackground.png');*/

/*}*/
/*.LoudSpeaker-list-body-main-button:hover{*/
/*  background-color: #3a8ee6;*/
/*  color: white;*/
/*}*/
i.icon-file-word-fill {
  color: #008dfa;
  font-size: 40px;
}
i.icon-wenjianjia{
  color: #f09f19;
  font-size: 40px;
}
i.icon-PDF{
  color: #eb5e5e;
  font-size: 40px;
}
i.icon-file-excel-fill{
  color: #00c090;
  font-size: 40px;
}
i.icon-file-ppt-fill{
  color: #ff7082;
  font-size: 40px;
}
.AchievementList-list-body-main-button {
  border:  none;
  color: rgb(241 247 255);
  outline: none;
  border-radius: 3px;
  width: 120px;
  height: 35px;
  text-align: center;
  background-image: url('/static/images/fourbackground.png');
}
.AchievementList-list-body-main-button-down{
  /*font-weight: bold;*/
  float: left;
  border: 1px solid rgb(132 198 252);
  margin-left: 10px;
  background-color: rgb(248 251 255);
  /* font-size: 15px; */
  /* border: none; */
  color: rgb(140 147 250);
  outline: none;
  border-radius: 3px;
  width: 85px;
  height: 35px;
  text-align: center;
  background-image: url(/static/images/fourbackground.png);
}
i.icon-daochu{
  color: rgb(52, 197, 231);;
  font-size: 18px;
}
i.icon-icon_wenjianjia{
  color: rgb(52, 197, 231);;
  font-size: 18px;
}
.icon-xiazai:before{
  font-size: 20px;
  margin-right: 8px;
}
.icon-daochu:before{
  font-size: 20px;
  margin-right: 8px;
}
.pending-items-search input{
  /*padding-left: 10px;*/
  width: 330px;
  margin-left: 10px;
  height: 35px;
  /* border-style: none; */
  /* align-items: inherit; */
  /* border-color: unset; */
  /* border-radius: 15px; */
  /* font-size: 14px; */
  /* font-weight: normal; */
  /* font-style: normal; */
  /*background: rgb(238, 244, 251);*/
/*!* outline-color: #caecf5;*/

}
i.icon-sousuo{
margin-left: -35px;
color:#d3d4d5;
}
.input-catch{
  -webkit-appearance: none;
  background-color: #FFF;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  /* height: 40px; */
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);

}
.paper-head-title button{
  border: 1px solid rgb(132 198 252);
  border-radius: 3px;
  width: 80px;
  background-color: rgb(248 251 255);
  height: 40px;
  text-align: center;
  background-image: url(/static/images/fourbackground.png);
}
.back-paper-button{
  color: rgb(140 147 250);
  font-weight: bold;
  outline: none;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/library/LibraryDataList.vue